import * as React from 'react';
import gql from 'graphql-tag';
import AuthorizedQuery from './AuthorizedQuery';

const FARM_FRAGMENT = `
  farm {
    id
    name
    geometry {
      coordinates
      type
    }
  }
`;

const LAYERS_FRAGMENT = `
  layers: library {
    nodes {
      id
      kind
      thumbnailUrl
      capturedOn
      createdOn
      ... on RasterDocument {
        rasterUrl
        meanNdvi
      }
    }
  }
`;

const FARM_QUERY = (props: Props) => gql(`
  query Field($id: ID!) {
    field(id: $id) {
      id
      name
      area
      geometry {
        coordinates
        type
      }
      ${props.includeFarm ? FARM_FRAGMENT : ''}
      ${props.includeLayers ? LAYERS_FRAGMENT : ''}
    }
  }
`);

interface Renders {
  field: Field | null;
  farm: Farm | null;
  layers: RasterDocument[] | null; 
  loading: boolean;
  refetch: () => void;
}

interface Props {
  fieldId?: string;
  includeFarm?: boolean;
  includeLayers?: boolean;
  children: (renders: Renders) => React.ReactNode;
}

const FarmProvider: React.StatelessComponent<Props> = (props: Props) => (
  <AuthorizedQuery query={FARM_QUERY(props)} variables={{id: props.fieldId}}>
    {({ data, loading, refetch }) => {
      return props.children({
        field: data && data.field,
        farm: data && data.field && data.field.farm,
        layers: data && data.field && data.field.layers && data.field.layers.nodes,
        loading,
        refetch
      });
    }}
  </AuthorizedQuery>
);

export default FarmProvider;


// WEBPACK FOOTER //
// ./src/providers/FieldProvider.tsx